import React, { useEffect, useState } from 'react';

import axios from 'axios';
import { useDispatch, useSelector } from 'react-redux';
import Loader from '../common/Loader';
import CardSlider from '../components/CardSlider';
import LatestNews from '../components/LatestNews';
import { default as MainSlider } from '../components/MainSlider';
import { getAllMovies } from '../store/actions/todosAction';
const Home = () => {
  const [showLoader, setShowLoader] = useState(true);
  setTimeout(() => {
    setShowLoader(false);
  }, 1000);
  useEffect(() => {
    axios
      .post('https://cineplex-web-api.cineplexbd.com/api/v1/login', {
        user_id: 'HlWnovnr0b2wMe1WGG4J1687260539652',
      })
      .then((response) => {
        // console.log('Response:', response.data.data);
        localStorage.setItem(
          'tokenCineplex',
          JSON.stringify(response.data.data)
        );
      })
      .catch((error) => {
        console.error('Error:', error);
      });
    // userToken, fetcher();
  }, []);

  const movie = useSelector((state) => state?.movie?.movieList);

  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(getAllMovies('popular'));
  }, []);

  return (
    <>
      {showLoader && (
        <div className='inline-block'>
          <Loader />
        </div>
      )}
      {!showLoader && (
        <>
          <MainSlider slider={movie} />
          <CardSlider />
          <LatestNews />
          {/* <OfferCard /> */}
        </>
      )}
    </>
  );
};

export default Home;
